import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { studyPreferencesReducer, StudyPreferencesStore } from '@magoosh/high_school/pages/calypso/reducers';
import { reducer as formReducer } from 'redux-form';
import { assignmentsReducer } from '@magoosh/high_school/pages/assignments/reducers';
import { AssignmentsStore } from '@magoosh/high_school/pages/assignments/types';
import { studyScheduleReducer } from '@magoosh/organisms/study_schedule/reducers';
import { StudyScheduleStore } from '@magoosh/organisms/study_schedule/types';
import { LessonModuleData } from '@magoosh/pages/lesson_modules/types';
import { lessonModuleReducer } from '@magoosh/pages/lesson_modules/reducers';

/**
 * Use to create a redux store
 * Does not accept initial state but that can be added when necessary
 */
export default function configureStore() {
  let devtools: any =
    typeof window !== 'undefined' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
    typeof (window as any).__REDUX_DEVTOOLS_EXTENSION__ === 'function' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__();

  if (!devtools) {
    devtools = (f: any) => f;
  }

  return createStore(
    combineReducers({
      assignments: assignmentsReducer,
      lessonModuleData: lessonModuleReducer,
      studyPreferences: studyPreferencesReducer,
      studySchedule: studyScheduleReducer,
      form: formReducer
    }),
    compose(applyMiddleware(thunk), devtools)
  );
}

export interface RootStore {
  assignments: AssignmentsStore;
  studyPreferences: StudyPreferencesStore;
  studySchedule: StudyScheduleStore;
  lessonModuleData: LessonModuleData;
  form: any;
}
